import {
  LOGIN,
  WHN_ARTICLES,
  ALL_ARTICLES_IN_EDITION,
  CLEAR_ALL_CURATION_CONTENT,
  EMAIL_BROWSER_CURATION_UNDO,
  GENERATE_PREVIEW,
  PREVIEW_ARTICLE,
} from "../../../constants/actionTypes";
import store from "../../../store/index";
import {
  getWhnArticlesService,
  clearAllCurationService,
  removeSingleArticleFromCurationService,
} from "../../Services/whnServices";
import { IArticlesItem } from "./../interfaces";
import { serializeArticles } from "./utils";
import Article from "./../../Design/Shared/Article";
import { updateArticleOrderService } from "modules/Services/AssetService";
import { EDITION_NAME_CHANGE } from "constants/types";
import { RemoveAllCurateFavoriteArticle } from "../Favorites/actions";
import { setDesignUpdate } from "modules/EmailBrowser/actions";

// async function callMyAccountsAPI() {
//   try {
//     const response = await getMyAccountsService();
//     return response.data;
//   } catch (err) {
//     console.log(err);
//     return [];
//   }
// }

export const checkWhnArticle = (data: any) => {
  store.dispatch({
    type: WHN_ARTICLES.ADD_CHECK,
    payload: data,
  });
};

export const uncheckWhnArticle = (data: any) => {
  store.dispatch({
    type: WHN_ARTICLES.REMOVE_CHECK,
    payload: data,
  });
};

export const uncheckAllWhnArticle = (data: any) => {
  store.dispatch({
    type: WHN_ARTICLES.REMOVE_ALL_CHECK,
  });
};

export const editionArticleReorder = (versionId: any, articleIdsString: string, articles: any) => {
  store.dispatch({
    type: GENERATE_PREVIEW.UPDATE,
    isUpdated: true,
  });
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.REORDER,
    payload: articles,
  });
  return updateArticleOrderService(versionId, articleIdsString);
};

export const getWhnArticles = (data: any) => {
  // var form_data = new FormData();
  // form_data.append("result_limit", JSON.stringify(data["result_limit"]));
  // form_data.append("result_offset", JSON.stringify(data["result_offset"]));
  store.dispatch({
    type: WHN_ARTICLES.LOAD,
  });
  getWhnArticlesService(data["result_limit"], data["result_offset"])
    .then((res) => {
      const serializedData: IArticlesItem[] = serializeArticles(res.data["articles"]);
      store.dispatch({
        type: WHN_ARTICLES.LOAD_SUCCESS,
        payload: serializedData,
      });
      store.dispatch({
        type: LOGIN.TURN_OFF_FIRST_LOGIN,
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: WHN_ARTICLES.LOAD_FAIL,
        payload: [],
      });
    });
};

//* Clear all curated articles of a particular edition
export const clearAllCuration = (versionId: number) => {
  store.dispatch({
    type: CLEAR_ALL_CURATION_CONTENT.LOAD,
  });
  clearAllCurationService(versionId)
    .then((res: any) => {
      if (res.data.success) {
        store.dispatch({
          type: CLEAR_ALL_CURATION_CONTENT.LOAD_SUCCESS,
        });
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.REMOVE_ALL_ARTICLES,
        });
      }

      store.dispatch({
        type: EDITION_NAME_CHANGE.CURATED_COUNT_UPDATE,
        payload: { versionId: versionId, count: 0 },
      });
      RemoveAllCurateFavoriteArticle();
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: CLEAR_ALL_CURATION_CONTENT.LOAD_FAIL,
      });
    });
};

//* Clear single curated articles of a particular edition
export const removeSingleArticleFromCuration = (
  versionId: number,
  articleId: number,
  count: number,
  articles?: any
) => {
  store.dispatch({
    type: CLEAR_ALL_CURATION_CONTENT.LOAD,
  });

  return removeSingleArticleFromCurationService(versionId, articleId)
    .then((res: any) => {
      if (res.data.success) {
        store.dispatch({
          type: CLEAR_ALL_CURATION_CONTENT.REMOVE_SINGLE_ARTICLE_LOAD_SUCCESS,
          payload: {
            articleId,
          },
        });
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.REMOVE_ARTICLE,
          payload: {
            articleId,
          },
        });

        // reset preview on edition page when empty
        // if (count === 1) {
        store.dispatch({ type: PREVIEW_ARTICLE.RESET });
        // }

        store.dispatch({
          type: EMAIL_BROWSER_CURATION_UNDO.SUCCESS,
          payload: {
            emailId: versionId,
            articles: articleId.toString(),
          },
        });
        store.dispatch({
          type: EDITION_NAME_CHANGE.CURATED_COUNT_UPDATE,
          payload: { versionId: versionId, count: count - 1 },
        });
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.UPDATE_CURATED_COUNT,
          payload: -1,
        });
        setDesignUpdate(true);
        if (articles) {
          store.dispatch({
            type: ALL_ARTICLES_IN_EDITION.UPDATE_ARTICLES_ORDER,
            payload: articles,
          });
        }
      }
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: CLEAR_ALL_CURATION_CONTENT.LOAD_FAIL,
      });
    });
};
